import axios from 'axios'
import { getHost } from './host'

export interface WrxOption {
    wrx_option_id: number;
    description: string; 
}

export async function getWrxOptions(api_key: string) {
  
    const url = `https://${getHost()}/api/wrx_options`    
    const { data } = await axios.get<WrxOption[]>(url, { headers: {'X-API-KEY': api_key, Accept: 'application/json'} });
    
    return data
}